function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import debounce from 'lodash/debounce';
import { raf, easeInOutCubic, addEventListener, getScroll } from '@cloud-sn/v-utils';
import { buildComponentName } from '../utils';
var __vue_script__ = {
  name: buildComponentName('BackTop'),
  props: {
    prefixCls: {
      type: String,
      default: 'ux-back-top'
    },
    visibilityHeight: {
      type: Number,
      default: 400
    },
    getTarget: {
      type: Function,
      default: function _default() {
        return window;
      }
    }
  },
  data: function data() {
    return {
      visible: false,
      scrollEvent: null
    };
  },
  computed: {
    classes: function classes() {
      var prefixCls = this.prefixCls;
      return _defineProperty({}, prefixCls, true);
    }
  },
  mounted: function mounted() {
    var getTarget = this.getTarget,
        handleScroll = this.handleScroll;
    var target = getTarget();
    this.scrollEvent = addEventListener(target, 'scroll', debounce(handleScroll, 50));
    this.handleScroll();
  },
  beforeDestroy: function beforeDestroy() {
    var scrollEvent = this.scrollEvent;

    if (scrollEvent) {
      scrollEvent.remove();
    }
  },
  methods: {
    handleScroll: function handleScroll() {
      var getTarget = this.getTarget,
          visibilityHeight = this.visibilityHeight;
      var target = getTarget();
      var scrollTop = getScroll(target, true);
      this.visible = scrollTop > visibilityHeight;
    },
    scroll: function scroll(scrollTop, startTime, target) {
      var scroll = this.scroll,
          setScrollTop = this.setScrollTop;
      var time = Date.now() - startTime;
      setScrollTop(easeInOutCubic(time, scrollTop, 0 - scrollTop, 450), target);

      if (time < 450) {
        raf(scroll.bind(this, scrollTop, startTime, target));
      }
    },
    setScrollTop: function setScrollTop(value, target) {
      var nTarget = target;

      if (nTarget === window) {
        document.body.scrollTop = value;
        document.documentElement.scrollTop = value;
      } else {
        nTarget.scrollTop = value;
      }
    },
    scrollToTop: function scrollToTop() {
      var getTarget = this.getTarget;
      var target = getTarget();
      var scrollTop = getScroll(target, true);
      var now = Date.now();

      if (scrollTop > 0) {
        this.scroll(scrollTop, now, target);
      }
    },
    onClick: function onClick(e) {
      this.scrollToTop();
      this.$emit('click', e);
    }
  }
};
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }],
    class: _vm.classes,
    on: {
      "click": _vm.onClick
    }
  }, [_vm._t("default", [_c('div', {
    class: _vm.prefixCls + "-content"
  }, [_c('div', {
    class: _vm.prefixCls + "-icon"
  })])])], 2)]);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "backtop.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  if (false) {
    var hook;

    if (false) {
      // In SSR.
      hook = function hook(context) {
        // 2.3 injection
        context = context || // cached call
        this.$vnode && this.$vnode.ssrContext || // stateful
        this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
        // 2.2 with runInNewContext: true

        if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
          context = __VUE_SSR_CONTEXT__;
        } // inject component styles


        if (style) {
          style.call(this, createInjectorSSR(context));
        } // register component module identifier for async chunk inference


        if (context && context._registeredComponents) {
          context._registeredComponents.add(moduleIdentifier);
        }
      }; // used by ssr in case component is cached and beforeCreate
      // never gets called


      component._ssrRegister = hook;
    } else if (style) {
      hook = shadowMode ? function (context) {
        style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
      } : function (context) {
        style.call(this, createInjector(context));
      };
    }

    if (hook !== undefined) {
      if (component.functional) {
        // register for functional component in vue file
        var originalRender = component.render;

        component.render = function renderWithStyleInjection(h, context) {
          hook.call(context);
          return originalRender(h, context);
        };
      } else {
        // inject component registration as beforeCreate hook
        var existing = component.beforeCreate;
        component.beforeCreate = existing ? [].concat(existing, hook) : [hook];
      }
    }
  }

  return component;
}
/* style inject */

/* style inject SSR */

/* style inject shadow dom */


var __vue_component__ = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

export default __vue_component__;